import { Paper, PaperProps } from "@mui/material";
import { ReactNode } from "react";

interface Props {
  children: ReactNode;
  padding?: "none" | "dense" | "normal";
  sx?: PaperProps["sx"];
}

/** Customizable pad/container for from controls and inputs. */
export function FormControlPad({ children, padding, sx }: Props) {
  return (
    <Paper
      sx={{
        paddingY: padding === "dense" ? 1 : padding === "normal" ? 2 : undefined,
        paddingX: padding === "dense" ? 1 : padding === "normal" ? 1.5 : undefined,
        backgroundColor: (th) => th.palette.background.default,
        ...sx,
      }}
      variant='elevation'
      elevation={0}
      square={false}
    >
      {children}
    </Paper>
  );
}
